/**
 * SecureImage Component
 * 
 * SEC-01 FIX: Loads images through Authorization header, not URL token.
 */
import { useState, useEffect } from 'react';
import { api } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export function SecureImage({ fileId, alt = '', className = '', onClick, ...props }) {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  
  useEffect(() => {
    if (!fileId) {
      setLoading(false);
      return;
    }
    
    let objectUrl = null;
    let isMounted = true;
    
    const loadImage = async () => {
      try {
        setLoading(true);
        setError(false);
        
        const response = await api.get(`/files/${fileId}/download`, {
          responseType: 'blob'
        });
        
        if (!isMounted) return;
        
        const blob = new Blob([response.data], { 
          type: response.headers['content-type'] || 'image/jpeg' 
        });
        
        objectUrl = URL.createObjectURL(blob);
        setImageUrl(objectUrl);
      } catch (err) {
        console.error('Failed to load secure image:', err);
        if (isMounted) setError(true);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    
    loadImage();
    
    return () => {
      isMounted = false;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [fileId]);
  
  if (loading) {
    return (
      <div className={`flex items-center justify-center bg-muted ${className}`} {...props}>
        <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
      </div>
    );
  }
  
  if (error || !imageUrl) {
    return (
      <div className={`flex items-center justify-center bg-muted text-muted-foreground ${className}`} {...props}>
        <span className="text-xs">Ошибка</span>
      </div>
    );
  }
  
  return (
    <img 
      src={imageUrl} 
      alt={alt} 
      className={className} 
      onClick={onClick}
      {...props} 
    />
  );
}

export default SecureImage;
